package app.view

import app.CustomRouter
import app.Routes
import app.api.CompaniesApi
import app.api.ProjectsApi
import app.api.StagesApi
import app.components.ModalStore
import app.components.buttonText
import app.components.warningModal
import app.svg.arrowDown
import app.svg.delete
import app.svg.office
import app.svg.stage
import app.utils.formatDateTime
import app.utils.getLightStatusBackgroundColor
import dev.fritz2.core.*

fun RenderContext.projectsView(projectsApi: ProjectsApi, companiesApi: CompaniesApi, stagesApi: StagesApi) {
    val showCreateProjectMenu = storeOf(false)
    val showCreateCompanyProjectMenuOfId = storeOf(0)
    val showCreateCompanyProjectStageMenuOfId = storeOf(0)
    val inputNameValue = storeOf("")
    val inputDescriptionValue = storeOf("")
    val selectedCompanyId = storeOf("")
    val selectedStageId = storeOf("")

    val showModalStore = storeOf(ModalStore(show = false, message = ""))
    warningModal(
        modalStore = showModalStore,
    )

    projectsApi.handler(Unit)
    projectsApi.data.render { projects ->
        if (projects.isEmpty()) {
            +"No projects found"
        }
        projects.forEach { project ->
            div("border rounded-md shadow-md my-4 p-4 group dark:bg-gray-800 dark:border-gray-700 dark:text-white") {
                div("mb-4") {
                    div("flex") {
                        button("text-xl") {
                            +project.name
                            clicks handledBy {
                                CustomRouter.projectDetail(
                                    mapOf(
                                        "route" to Routes.PROJECT_DETAIL,
                                        Routes.Params.PROJECT_ID to project.id.toString(),
                                    )
                                )
                            }
                        }
                        div("my-auto mx-2 flex gap-2 invisible group-hover:visible") {
                            button {
                                clicks handledBy showCreateCompanyProjectMenuOfId.handle { currentId ->
                                    selectedCompanyId.update("")
                                    if (currentId == project.id) 0 else project.id
                                }
                                title("Create CompanyProject")
                                office("size-4")
                            }
                            button {
                                clicks handledBy {
                                    showModalStore.update(
                                        ModalStore(
                                            show = true,
                                            message = "Are you sure you want to delete ${project.name}? " +
                                                    "Deleting the project will automatically delete all " +
                                                    "associated stages and deployments as well.",
                                            onConfirm = { projectsApi.deleteProject(project.id) }
                                        )
                                    )
                                }
                                title("Delete CompanyProject")
                                delete("size-4")
                            }
                        }
                    }
                    p("text-sm") {
                        +(project.description ?: "")
                    }
                }
                showCreateCompanyProjectMenuOfId.data.render { show ->
                    if (show == project.id) {
                        companiesApi.handler(Unit)
                        companiesApi.data.render { companies ->
                            div("w-full flex mb-4 gap-4") {
                                if (companies.isEmpty()) {
                                    +"No companies found"
                                } else {
                                    select(
                                        "w-52 p-2 border rounded " +
                                                "dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                                    ) {
                                        option {
                                            value("")
                                            +"Select company"
                                        }
                                        companies.forEach { company ->
                                            option {
                                                value("${company.id}")
                                                +company.name
                                            }
                                        }
                                        changes.values() handledBy selectedCompanyId.update
                                    }
                                    selectedCompanyId.data.render { selectedId ->
                                        buttonText(
                                            text = "Submit",
                                            isDisabled = selectedId == "",
                                            onClick = {
                                                projectsApi.postCompanyProject(Pair(project.id, selectedId))
                                                selectedCompanyId.update("")
                                                showCreateCompanyProjectMenuOfId.update(0)
                                            }
                                        )
                                    }
                                }
                            }
                        }
                    }
                }
                div("flex flex-col gap-4") {
                    project.companyProjects.forEach { company ->
                        div("flex flex-row gap-4 items-start") {
                            div("w-40 group/companyproject") {
                                div("border rounded-lg h-20 dark:border-gray-700 dark:bg-gray-800") {
                                    div("flex font-semibold p-2") {
                                        p("font-semibold") {
                                            +company.name
                                        }
                                        div("flex gap-2 my-auto ml-auto invisible group-hover/companyproject:visible") {
                                            button {
                                                clicks handledBy showCreateCompanyProjectStageMenuOfId.handle {
                                                    selectedStageId.update("")
                                                    if (it == company.id) 0 else company.id
                                                }
                                                title("Create CompanyProjectStage")
                                                stage("size-4")
                                            }
                                            button {
                                                clicks handledBy {
                                                    showModalStore.update(ModalStore(
                                                        show = true,
                                                        message = "Are you sure you want to delete " +
                                                                "${project.name}-${company.name}? " +
                                                                "Deleting the company project will automatically " +
                                                                "delete all associated stages and deployments as well.",
                                                        onConfirm = {
                                                            projectsApi.deleteCompanyProject(
                                                                company.id
                                                            )
                                                        }
                                                    )
                                                    )
                                                }
                                                title("Delete CompanyProject")
                                                delete("size-4")
                                            }
                                        }

                                    }
                                }
                            }
                            div("flex flex-row gap-4 overflow-x-auto") {
                                showCreateCompanyProjectStageMenuOfId.data.render { show ->
                                    if (show == company.id) {
                                        stagesApi.handler(Unit)
                                        stagesApi.data.render { stages ->
                                            div("w-40") {
                                                div("border rounded-lg flex flex-col") {
                                                    if (stages.isEmpty()) {
                                                        +"No stages found"
                                                    } else {
                                                        select(
                                                            "w-auto p-2 border rounded dark:bg-gray-700 " +
                                                                    "dark:border-gray-600 dark:text-white"
                                                        ) {
                                                            option {
                                                                value("")
                                                                +"Select stage"
                                                            }
                                                            stages.forEach {
                                                                option {
                                                                    value("${it.id}")
                                                                    +it.name
                                                                }
                                                            }
                                                            changes.values() handledBy selectedStageId.update
                                                        }
                                                        selectedStageId.data.render { selectedId ->
                                                            buttonText(
                                                                text = "Submit",
                                                                isDisabled = selectedId == "",
                                                                onClick = {
                                                                    projectsApi.postCompanyProjectStage(
                                                                        Pair(company.id, selectedId)
                                                                    )
                                                                    selectedStageId.update("")
                                                                    showCreateCompanyProjectStageMenuOfId.update(0)
                                                                }
                                                            )
                                                        }
                                                    }

                                                }
                                            }
                                        }
                                    }
                                }
                                company.stages.sortedBy { it.ordering }.forEach { stage ->
                                    button(
                                        "w-40 border rounded-lg h-20 flex relative group/stage dark:border-gray-700 " +
                                                getLightStatusBackgroundColor(stage.latestRolloutExecution)
                                    ) {
                                        disabled(stage.latestRolloutExecution == null)
                                        clicks handledBy {
                                            CustomRouter.rollout(
                                                mapOf(
                                                    "route" to Routes.ROLLOUT,
                                                    Routes.Params.PROJECT_ID to project.id.toString(),
                                                    Routes.Params.ROLLOUT_ID to stage.latestRolloutExecution?.id.toString(),
                                                )
                                            )
                                        }
                                        div("flex p-1 h-min w-full") {
                                            p("font-semibold") { +stage.name }
                                            button("ml-auto my-auto invisible group-hover/stage:visible") {
                                                clicks {
                                                    preventDefault()
                                                    stopPropagation()
                                                } handledBy {
                                                    showModalStore.update(ModalStore(
                                                        show = true,
                                                        message = "Are you sure you want to delete ${stage.name} " +
                                                                "of ${project.name}-${company.name}? Deleting " +
                                                                "the stage will automatically delete all " +
                                                                "associated deployments as well.",
                                                        onConfirm = {
                                                            projectsApi.deleteCompanyProjectStage(stage.id)
                                                        }
                                                    ))
                                                }
                                                title("Delete CompanyProjectStage")
                                                delete("size-4")
                                            }
                                        }
                                        p("text-xs absolute right-0 bottom-0 p-1") {
                                            if (stage.latestRolloutExecution != null) {
                                                div("flex flex-col") {
                                                    div("ml-auto text-sm font-semibold") {
                                                        +"${stage.latestRolloutExecution.version}"
                                                    }
                                                    div {
                                                        +formatDateTime(stage.latestRolloutExecution.startedAt)
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    // Create Project Menu
    div("flex flex-col mt-4") {
        showCreateProjectMenu.data.render { show ->
            div(if (!show) "hidden" else "w-full flex mb-4 gap-4") {
                input(
                    "border w-full rounded-lg p-2 h-14 " +
                            "dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:placeholder-gray-400"
                ) {
                    placeholder("Name")
                    value(inputNameValue.data)
                    changes.values() handledBy inputNameValue.update
                }
                input(
                    "border w-full rounded-lg p-2 h-14 " +
                            "dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:placeholder-gray-400"
                ) {
                    placeholder("Description")
                    value(inputDescriptionValue.data)
                    changes.values() handledBy inputDescriptionValue.update
                }
                inputNameValue.data.render {
                    buttonText(
                        text = "Submit",
                        isDisabled = it == "",
                        onClick = {
                            projectsApi.postProject(Pair(inputNameValue.current, inputDescriptionValue.current))
                            inputNameValue.update("")
                            inputDescriptionValue.update("")
                            showCreateProjectMenu.update(false)
                        }
                    )
                }
            }
            button("m-auto dark:text-white") {
                clicks handledBy showCreateProjectMenu.handle { it.not() }
                title(if (!show) "Create Project" else "Close")
                arrowDown(if (!show) "size-6" else "size-6 rotate-180")
            }
        }
    }
}
